import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { Link } from 'app/core/models/link.model';
import { ShebaGtmModule } from 'app/core/services/google-tag-manager/gtm.directive';

@Component({
  selector: 'sheba-footer-links',
  templateUrl: 'footer-links.component.html',
  standalone: true,
  imports: [MatRippleModule, RouterLinkDetectorDirective, TranslateModule, ShebaGtmModule],
  host: {
    class: 'flex'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShebaFooterLinksComponent {
  termsOfUseLink = input<Link>();
  sitesPolicyLink = input<Link>();
  allRightsReservedLink = input<Link>();
  accessibilityStatementLink = input<Link>();
}
